import styles from './Testimonials.module.css'
import useReveal from '../hooks/useReveal.js'

const QUOTES = [
  {
    quote: "We had a ranked shortlist of five within two days \u2014 all genuinely relevant. It used to take our old agency three weeks to get us that far.",
    name: 'Anika Patel',
    role: 'Head of Engineering, Harbourline Logistics \u00b7 Wellington',
  },
  {
    quote: "The feedback after each interview was the most useful part. Nobody had ever told me why I didn\u2019t get a role before \u2014 just that I hadn\u2019t.",
    name: 'Josh Ngata',
    role: 'Operations Analyst, placed with a Christchurch manufacturer',
  },
]

export default function Testimonials() {
  const [ref, visible] = useReveal()

  return (
    <section className={styles.section}>
      <div ref={ref} className={`container ${styles.grid} ${visible ? styles.visible : ''}`}>
        {QUOTES.map((q) => (
          <figure key={q.name} className={styles.card}>
            <blockquote className={styles.quote}>{q.quote}</blockquote>
            <figcaption className={styles.caption}>
              <span className={styles.name}>{q.name}</span>
              <span className={styles.role}>{q.role}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
